import { useParams, Navigate } from "react-router-dom";
import { servicesContent, servicesCategoriesByPath } from "@/data/servicesContent";
import ServiceDetail from "@/pages/ServiceDetail";
import ServiceCategory from "@/pages/ServiceCategory";
import MarketingLanding from "@/pages/MarketingLanding";
import PrivateAILanding from "@/pages/PrivateAILanding";
import AuditsLanding from "@/pages/AuditsLanding";
import WebEngineeringLanding from "@/pages/WebEngineeringLanding";
import LaunchpadLanding from "@/pages/LaunchpadLanding";
import OsLanding from "@/pages/OsLanding";

export default function ServicesDispatch() {
  const { slug } = useParams();
  // GEO has its own dedicated top-level page
  if (slug === "geo") return <Navigate to="/geo" replace />;
  // Bespoke direct-response landings per category
  if (slug === "marketing") return <MarketingLanding />;
  if (slug === "private-ai") return <PrivateAILanding />;
  if (slug === "audits") return <AuditsLanding />;
  if (slug === "web-engineering") return <WebEngineeringLanding />;
  if (slug === "launch") return <LaunchpadLanding />;
  if (slug === "os") return <OsLanding />;
  const categoryKey = servicesCategoriesByPath[slug];
  if (categoryKey) return <ServiceCategory categoryKey={categoryKey} />;
  if (servicesContent[slug]) return <ServiceDetail />;
  return <Navigate to="/services" replace />;
}
